import { dayjs } from 'services/dayjs';
import { User } from 'services/interface';
import { isInOrganization } from 'services/accessControl';

const hasExpired = (date?: string): boolean => Boolean(date) && dayjs(date).isBefore(dayjs());

export const getExpiredLicenseStatus = (user: User | null): boolean => {
    if (user?.paid_user !== 1) {
        return false;
    }

    const expirationDate = isInOrganization(user) ? user?.organization?.expiration_date : user?.expiration_date;

    return hasExpired(expirationDate);
};

/**
 * MDCL-17831: the org-scoped workflow list (`/api/workflow/organization`) is only usable while the
 * organization's license is active. Once it lapses, a member still holding a valid personal
 * (standard) license owns apikey-scoped workflows, so route them to `/api/workflow` rather than
 * leaving them stuck on a dead org endpoint.
 */
export const shouldUseOrgWorkflowEndpoint = (user: User | null | undefined): boolean =>
    isInOrganization(user) && !hasExpired(user?.organization?.expiration_date);
